export default __webpack_public_path__ + "static/media/payment-visa.cbd11592.svg";